var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEducationHat = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#education_hat_svg__a)",
  stroke: "#3A434A",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.275 15.278V9.942l3.1 1.254a7 7 0 0 0 5.25 0l3.1-1.254v5.336c0 .814-.347 1.587-1.08 1.94-1.186.572-3.04 1.174-4.645 1.174-1.605 0-3.459-.602-4.644-1.174-.734-.353-1.08-1.126-1.08-1.94Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.524 6.35 5.946 4.23a9.25 9.25 0 0 1 8.002 0L18.37 6.35c.946.454.946 1.8 0 2.254l-4.422 2.122a9.25 9.25 0 0 1-8.002 0L1.524 8.604c-.946-.454-.946-1.8 0-2.254Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.074 7.477v4.686",
  strokeLinecap: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "education_hat_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgEducationHat;